import React, { Component } from 'react';
import { connect } from 'react-redux';
import { clearError, clearSuccess } from './snackbars-actions';
import ErrorMessageView from './error-message-view';
import SuccessMessageView from './success-message-view';

class Snackbars extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: null,
      showError: false,
      successMessage: null,
      showSuccess: false
    };

    this.hideErrorTimeout = null;
    this.removeErrorTextTimeout = null;
    this.hideSuccessTimeout = null;
    this.removeSuccessTextTimeout = null;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.errorMessage && !this.props.errorMessage) this.newError(nextProps.errorMessage);
    if (nextProps.successMessage && !this.props.successMessage) this.newSuccess(nextProps.successMessage);
  }

  newSuccess = (successMessage) => {
    this.removeSuccessTextTimeout && clearTimeout(this.removeSuccessTextTimeout);
    this.setState({successMessage: successMessage, showSuccess: true}, () => {
      this.props.clearSuccess();
    });
    this.hideSuccessTimeout && clearTimeout(this.hideSuccessTimeout);
    this.hideSuccessTimeout = setTimeout(() => this.successCleared(), 3000)
  };

  newError = (errorMessage) => {
    this.removeErrorTextTimeout && clearTimeout(this.removeErrorTextTimeout);
    this.setState({errorMessage: errorMessage, showError: true}, () => {
      this.props.clearError();
    });
    this.hideErrorTimeout && clearTimeout(this.hideErrorTimeout);
    this.hideErrorTimeout = setTimeout(() => this.errorCleared(), 3000)
  };

  successCleared = () => {
    this.setState({showSuccess: false});
    this.removeSuccessTextTimeout && clearTimeout(this.removeSuccessTextTimeout);
    this.removeSuccessTextTimeout = setTimeout(() => this.setState({successMessage: null}), 600)
  };

  errorCleared = () => {
    this.setState({showError: false});
    this.removeErrorTextTimeout && clearTimeout(this.removeErrorTextTimeout);
    this.removeErrorTextTimeout = setTimeout(() => this.setState({errorMessage: null}), 600)
  };

  render() {
    return <div>
      <ErrorMessageView {...this.props} errorMessage={this.state.errorMessage} showError={this.state.showError}/>
      <SuccessMessageView {...this.props} successMessage={this.state.successMessage} showSuccess={this.state.showSuccess}/>
    </div>
  }

}

const mapStateToProps = (state) => ({
  errorMessage: state.snackbars.errorMessage,
  successMessage: state.snackbars.successMessage
});

const mapDispatchToProps = {
  clearError: clearError,
  clearSuccess: clearSuccess
};

export default connect(mapStateToProps, mapDispatchToProps)(Snackbars);



// WEBPACK FOOTER //
// ./src/components/snackbars/snackbars.js